import { useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const useCenteredSnackbar = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const showCentered = (message, options = {}) => {
        const action = key => (
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => closeSnackbar(key)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        );

        return enqueueSnackbar(message, {
            ...options,
            action: options.action !== false ? (options.action || action) : undefined,
            style: {
                position: 'fixed',
                top: '50%',
                // left: '50%',
                transform: 'translate(-50%, -50%)',
                minWidth: '300px',
                maxWidth: '90vw',
                flexWrap :'nowrap',
                borderRadius: '8px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
                zIndex: 9999,
                backgroundColor: options.variant === 'error' ? '#f44336' :
                    options.variant === 'success' ? '#4caf50' :
                        options.variant === 'warning' ? '#ff9800' : '#2196f3',
                color: 'white',
                padding: '16px 24px',
                fontSize: '16px',
                textAlign: 'center',
                ...options.style,
            },
            // Override anchorOrigin
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
        });
    };

    return {
        showCenteredPopup: showCentered,
        closeSnackbar,
        // Optional: keep original enqueueSnackbar for non-centered messages
        enqueueSnackbar
    };
};